import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'

import arrowLeft from '../../../../../images/arrow-left-light.svg'
import styles from '../modal-add-content-to-lists.css'

const ModalHeader = ({ title, showBackButton, onBack }) => (
  <div className={styles.header}>
    {showBackButton && (
      <button
        type="button"
        className={styles.backButton}
        onClick={onBack}
      >
        <ReactSVG
          src={arrowLeft}
        />
      </button>
    )}
    <div className={styles.title}>
      {title}
    </div>
  </div>
)

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func.isRequired
}

ModalHeader.defaultProps = {
  showBackButton: false
}

export default ModalHeader
